import { IJsonQueryPolygon } from 'shared/common/packages/api-models/common/json_query';

import { apiCall } from '../apiCall';

const MICROFRONTEND_NAME = 'desktop-filters-micro-frontend';

export const getDesktopFiltersMicrofrontendApi = () => {
  return {
    addPolygonFilter: (polygon: IJsonQueryPolygon) => {
      return apiCall(MICROFRONTEND_NAME, '/v1/add-polygon-filter', polygon);
    },
    removePolygonFilter: () => {
      return apiCall(MICROFRONTEND_NAME, '/v1/remove-polygon-filter');
    },
  };
};
